import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import { formatArrivalScheduleStatusLabel } from '#/modules/srmMgmt/purchaseOrder/helper/arrivalScheduleStatus';

const ArrivalScheduleStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatArrivalScheduleStatusLabel(status)}
    size={size}
    className={className}
  />
);

ArrivalScheduleStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default ArrivalScheduleStatusBadge;
